import { createStore } from 'satcheljs';
// Import mutators so they are initialized at the same time as the store
import '../mutators/removeMessageAdListMutator';
var initialMessageAdListViewStatusStore = {
    selectedAdId: null,
    listRemoved: false,
};
var store = createStore('messageAdListViewStatusStore', initialMessageAdListViewStatusStore)();
export default store;
//# sourceMappingURL=store.js.map